import { useEffect } from "react";
import { ArrowLeft } from "lucide-react";

const sections = [
  {
    title: "1. Titolare del trattamento",
    body: "Il Titolare del trattamento dei dati personali è Francesco Galli (\u201cil Titolare\u201d), con sede in Milano. Per qualsiasi richiesta relativa ai tuoi dati puoi scrivere a francescogallicoach@icloud.com.",
  },
  {
    title: "2. Dati raccolti",
    body: "Attraverso il form di candidatura raccogliamo i dati che fornisci volontariamente: nome, cognome, indirizzo email, numero di telefono, l'ambito di interesse (business, solitudine, sport), la fascia di budget indicata, la descrizione della tua sfida attuale e le tue motivazioni.",
  },
  {
    title: "3. Finalità del trattamento",
    body: "I dati sono trattati esclusivamente per: (a) valutare la tua candidatura a un percorso di coaching; (b) ricontattarti per fissare la call conoscitiva; (c) inviarti, solo se pertinente, risorse e comunicazioni relative ai servizi offerti. Non viene effettuata alcuna profilazione automatizzata con effetti giuridici.",
  },
  {
    title: "4. Base giuridica",
    body: "Il trattamento si fonda sul consenso esplicito che presti al momento dell'invio del form (art. 6, par. 1, lett. a del Reg. UE 2016/679 \u2013 GDPR) e sull'esecuzione di misure precontrattuali adottate su tua richiesta (lett. b).",
  },
  {
    title: "5. Modalità e conservazione",
    body: "I dati sono conservati con misure di sicurezza adeguate e per il tempo strettamente necessario alle finalità indicate. In assenza di un rapporto contrattuale, i dati di candidatura vengono cancellati entro 24 mesi dall'ultimo contatto, salvo diversa richiesta.",
  },
  {
    title: "6. Comunicazione a terzi",
    body: "I dati possono essere trattati da fornitori di servizi tecnologici (es. provider email e strumenti di prenotazione) nominati Responsabili del trattamento, esclusivamente per conto del Titolare. I dati non vengono venduti n\u00e9 ceduti a terzi per finalit\u00e0 di marketing.",
  },
  {
    title: "7. I tuoi diritti",
    body: "In qualsiasi momento puoi esercitare i diritti previsti dagli artt. 15-22 del GDPR: accesso, rettifica, cancellazione, limitazione, portabilit\u00e0, opposizione e revoca del consenso. Per farlo, scrivi a francescogallicoach@icloud.com. Hai inoltre il diritto di proporre reclamo al Garante per la protezione dei dati personali.",
  },
  {
    title: "8. Cookie",
    body: "Questo sito utilizza esclusivamente cookie tecnici necessari al corretto funzionamento. Non vengono impiegati cookie di profilazione senza il tuo preventivo consenso.",
  },
];

export default function PrivacyPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-background" data-testid="privacy-page">
      <header className="border-b border-white/10">
        <div className="max-w-[900px] mx-auto px-6 md:px-10 h-20 flex items-center justify-between">
          <a href="/" className="text-left" data-testid="privacy-logo">
            <span className="block font-serif text-lg tracking-tight text-foreground leading-none">
              Francesco Galli
            </span>
            <span className="block text-[10px] tracking-[0.35em] text-primary mt-1">
              MENTAL COACH
            </span>
          </a>
          <a
            href="/"
            className="inline-flex items-center gap-2 text-sm tracking-[0.1em] text-muted-foreground hover:text-primary transition-colors duration-300"
            data-testid="privacy-back"
          >
            <ArrowLeft size={16} /> TORNA AL SITO
          </a>
        </div>
      </header>

      <main className="max-w-[900px] mx-auto px-6 md:px-10 py-20 md:py-28">
        <div className="flex items-center gap-4 mb-6">
          <span className="h-px w-10 bg-primary" />
          <span className="text-[11px] tracking-[0.35em] text-primary">
            INFORMATIVA PRIVACY
          </span>
        </div>
        <h1 className="font-serif font-light text-4xl md:text-5xl text-foreground leading-tight mb-6">
          Informativa sul trattamento dei dati personali
        </h1>
        <p className="text-muted-foreground leading-relaxed mb-16 max-w-2xl">
          La tua riservatezza è parte integrante del mio lavoro. Qui trovi come
          raccolgo e tratto i dati che condividi attraverso questo sito, nel
          pieno rispetto del Regolamento UE 2016/679 (GDPR).
        </p>

        <div className="space-y-12">
          {sections.map((s, i) => (
            <section key={i} className="border-t border-white/10 pt-8">
              <h2 className="font-serif text-2xl text-foreground mb-3">
                {s.title}
              </h2>
              <p className="text-muted-foreground leading-relaxed max-w-2xl">
                {s.body}
              </p>
            </section>
          ))}
        </div>

        <div className="mt-16 pt-8 border-t border-white/10 text-xs text-muted-foreground">
          Ultimo aggiornamento: {new Date().toLocaleDateString("it-IT", { year: "numeric", month: "long" })}. Documento informativo semplificato: per esigenze legali specifiche rivolgiti a un consulente.
        </div>
      </main>
    </div>
  );
}
